var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDinoDab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 650",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 500,
    cy: 502.764,
    rx: 500,
    ry: 125.282,
    style: {
      fill: "rgb(15,36,35)",
      fillOpacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.469959,2.2184e-07,3.2988e-07,0.404343,-14.9816,200.946)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 455.911,
    cy: 582.863,
    rx: 210.993,
    ry: 37.606,
    style: {
      fill: "rgb(36,51,69)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939457,0.342666,-0.750055,2.05636,471.028,-805.376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.872,438.065L71.975,438.065L76.703,591.629L207.872,569.772L207.872,438.065Z",
    style: {
      fill: "rgb(58,74,94)"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.999999,0,0,0.999999,-19.9996,-107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.965,544.435L117.68,543.936L228.42,226.531C228.575,226.089 228.9,225.727 229.323,225.526C229.746,225.326 230.232,225.303 230.672,225.464L358.342,272.031C359.25,272.362 359.717,273.367 359.386,274.275L264.029,544.704L257.238,544.512L355.498,274.719L231.14,229.36L121.965,544.435Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939457,0.342666,-0.342666,0.939457,257.008,-215.698)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      fill: "rgb(32,175,228)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939457,0.342666,-0.342666,0.939457,275.454,-266.269)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939457,0.342666,-0.342666,0.939457,295.228,-317.664)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939457,0.342666,-0.342666,0.939457,314.363,-367.504)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939457,0.342666,-0.342666,0.939457,238.461,-164.849)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939457,0.342666,-0.342666,0.939457,217.628,-230.062)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939457,0.342666,-0.342666,0.939457,236.074,-280.633)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      fill: "rgb(32,175,228)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939457,0.342666,-0.342666,0.939457,255.848,-332.028)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939457,0.342666,-0.342666,0.939457,274.983,-381.868)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      fill: "rgb(32,175,228)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6989,0.61967,-0.545911,1.49668,166.55,-515.882)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      fill: "rgb(32,175,228)",
      stroke: "black",
      strokeWidth: "2.05px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939457,0.342666,-0.342666,0.939457,178.017,-244.51)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      fill: "rgb(32,175,228)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939457,0.342666,-0.342666,0.939457,196.463,-295.081)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939457,0.342666,-0.342666,0.939457,216.237,-346.476)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939457,0.342666,-0.342666,0.939457,216.237,-346.476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.735,513.98L181.298,538.224L172.455,546.635L188.735,546.635L188.735,513.98Z",
    style: {
      fill: "rgb(32,175,228)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939457,0.342666,-0.342666,0.939457,235.372,-396.316)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939457,0.342666,-0.342666,0.939457,159.47,-193.661)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      fill: "rgb(32,175,228)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32193,0,0,1.32193,452.988,-550.357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.951,579.475C303.264,601.692 309.393,610.839 315.523,597.215C321.266,605.956 310.263,610.28 307.982,620.745C305.887,630.357 315.262,639.469 325.175,634.718C318.647,669.955 278.421,666.071 269.057,650.684C263.704,641.889 265.689,633.203 270.128,623.237C272.947,633.474 286.405,628.946 286.186,622.033C285.966,615.106 273.277,616.302 276.623,605.096C277.545,602.009 292.674,589.806 294.951,579.475ZM286.846,571.607C279.68,573.237 283.582,556.601 265.604,563.32C263.4,541.659 294.745,554.7 294.517,540.33C304.383,557.579 288.21,556.784 286.846,571.607ZM300.338,535.488C297.01,535.384 295.351,531.349 296.262,528.947C298.463,523.141 313.57,525.586 317.986,519.219C321.44,529.448 302.393,525.758 300.338,535.488ZM299.052,515.522C302.08,513.666 302.47,516.259 302.372,517.269C302.274,518.28 297.156,522.063 296.438,521.072C295.721,520.082 298.356,515.949 299.052,515.522Z",
    style: {
      fill: "rgb(255,92,13)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32193,0,0,1.32193,452.988,-550.357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.075,593.594C293.339,603.579 308.67,611.787 311.05,605.582C313.443,611.656 304.88,615.592 302.599,626.057C300.504,635.669 312.938,641.545 322.851,636.793C318.224,664.761 280.04,665.5 270.675,650.112C265.322,641.317 266.058,637.137 270.497,627.171C275.164,633.704 289.549,632.406 289.329,625.493C289.11,618.565 280.522,603.598 293.075,593.594ZM284.102,562.399C280.47,555.979 273.667,560.726 271.8,559.291C270.317,558.152 271.087,553.333 272.899,553.791C274.95,554.309 286.111,550.924 284.102,562.399Z",
    style: {
      fill: "rgb(255,152,36)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.76072,0,0,1.73724,356.385,-97.7571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.451,219.048C258.831,220.609 259.393,218.604 263.689,222.759C263.688,221.599 265.492,219.347 266.356,219.042C267.644,226.224 271.198,220.234 271.714,221.199C272.194,218.472 277.996,219.722 278.776,215.789C279.421,212.535 280.107,210.371 275.553,199.78C276.905,200.961 280.196,203.868 281.104,207.954C282.247,207.066 282.791,205.271 284.835,203.8C282.476,207.284 277.975,223.1 285.515,224.047C288.41,225.551 288.954,227.835 290.627,229.875C294.204,229.484 295.506,226.568 296.364,224.129C295.145,247.541 262.3,242.333 258.453,233.012C257.237,230.066 255.91,227.093 257.451,219.048Z",
    style: {
      fill: "rgb(254,208,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32193,0,0,1.32193,160.824,5.20325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M526.258,224.527C528.347,228.203 522.018,235.209 519.077,236.32C495.111,238.426 488.445,225.833 489.365,214.869C489.471,213.596 498.696,222.632 501.027,222.603C500.06,220.701 502.16,217.459 503.065,215.837C503.909,218.245 508.797,226.637 513.7,227.312C516.723,209.611 513.557,199.158 509.978,195.565C521.966,195.524 520.922,216.551 520.8,224.415C520.775,226.078 522.291,222.543 522.711,219.415C523.309,219.228 522.086,226.758 522.807,228.021C523.643,229.486 526.182,227.592 526.258,224.527Z",
    style: {
      fill: "rgb(255,251,224)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.396949,4.485e-08,-1.4128e-07,0.404343,659.191,224.937)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 455.911,
    cy: 582.863,
    rx: 210.993,
    ry: 37.606,
    style: {
      fill: "rgb(15,36,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,983.109,-107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.578,567.613L86.258,567.613L53.761,423.741L186.318,393.8L225.578,567.613Z",
    style: {
      fill: "rgb(58,74,94)"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.00357573,-107.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M759.515,567.613L755.7,567.613L795.085,393.414C795.298,392.471 796.235,391.88 797.178,392.093L929.736,422.034C930.678,422.247 931.27,423.184 931.057,424.127L901.61,567.613L895.454,567.613L927.257,425.062L798.114,395.892L759.515,567.613Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.975427,-0.220323,-0.220323,0.975427,1095.38,-96.174)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      fill: "rgb(32,175,228)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,983.109,-107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.944,430.19L173.16,429.462L168.867,438.582L163.869,436.917L161.215,438.874L157.33,421.673L173.21,418.086L175.944,430.19Z",
    style: {
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1053.26,-35.9673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.944,430.19L173.16,429.462L168.867,438.582L163.869,436.917L161.215,438.874L157.33,421.673L173.21,418.086L175.944,430.19Z",
    style: {
      fill: "rgb(32,175,228)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,983.109,-107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.944,430.19L180.404,449.938L164.525,453.525L161.215,438.874L163.869,436.917L168.867,438.582L173.16,429.462L175.944,430.19Z",
    style: {
      fill: "rgb(32,175,228)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1053.26,-35.9673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.944,430.19L180.404,449.938L164.525,453.525L161.215,438.874L163.869,436.917L168.867,438.582L173.16,429.462L175.944,430.19Z",
    style: {
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.975427,-0.220323,-0.220323,0.975427,1083.45,-43.3777)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.975427,-0.220323,-0.220323,0.975427,1136.27,-86.9384)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.975427,-0.220323,-0.220323,0.975427,1148.13,-139.446)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.975427,-0.220323,-0.220323,0.975427,1189.25,-130.157)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      fill: "rgb(32,175,228)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,983.109,-107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.821,567.613L140.639,567.613L133.809,537.374L162.526,530.888L170.821,567.613Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.00357573,-107.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M814.479,567.613L810.583,567.613L818.878,530.502C819.091,529.559 820.028,528.968 820.971,529.181L849.687,535.667C850.63,535.88 851.222,536.817 851.009,537.76L844.512,567.613L840.95,567.613L847.209,538.695L821.906,532.98L814.479,567.613Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,983.109,-107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.784,567.613L104.094,567.613L99.099,545.502L114.979,541.915L120.784,567.613Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32193,0,0,1.32193,-732.64,136.264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M707.022,169.385C696.583,155.172 703.901,140.278 709.984,138.148C707.547,145.358 710.317,167.21 720.957,164.13C744.331,157.364 732.842,128.971 739.445,116.814C744.975,106.634 765.339,96.612 765.807,76.628C769.113,80.623 770.71,99.174 756.7,116.632C773.268,120.462 773.627,130.202 772.495,137.885C754.703,124.555 748.301,139.393 746.519,141.479C749.792,140.639 756.721,135.837 756.66,140.458C756.59,145.694 742.597,145.946 739.7,152.681C725.163,186.474 743.335,190.91 750.381,182.035C752.183,175.934 745.855,174.727 745.888,170.424C745.911,167.3 746.656,163.853 754.098,164.397C764.405,165.151 755.565,180.084 757.939,191.774C761.946,193.124 766.821,185.91 771.133,190.357C780.764,200.289 783.349,216.298 782.669,227.691C782.111,237.021 765.147,247.13 750.46,246.035C741.597,245.374 714.339,238.89 714.625,222.492C714.765,214.506 726.163,218.323 718.678,202.791C724.839,207.979 734.635,207.703 736.028,198.178C737.902,185.377 715.612,181.08 707.022,169.385Z",
    style: {
      fill: "rgb(255,92,13)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32193,0,0,1.32193,-596.814,-138.842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.218,375C625.535,379.764 626.043,380.257 626.925,377.839C627.002,382.27 628.795,388.645 631.246,390.861C636.36,395.486 644.711,396.085 648.633,391.144C650.435,385.043 645.108,383.836 645.14,379.533C645.164,376.409 648.617,374.716 650.554,375C660.779,376.498 647.225,399.715 653.26,401.748C657.268,403.098 664.159,398.277 668.471,402.724C678.102,412.655 679.602,424.407 678.921,435.8C678.363,445.13 662.399,454.239 647.712,453.144C638.849,452.484 614.36,447.692 614.647,431.294C614.787,423.308 624.293,424.919 619.784,415.183C625.945,420.371 633.771,415.481 635.165,405.957C637.038,393.155 614.864,389.189 606.274,377.495C604.193,374.66 602.817,371.799 601.997,369.018C604.088,371.738 609.557,380.42 614.022,380.274C615.437,380.228 615.533,378.382 612.504,375C613.663,373.706 618.762,383.105 622.3,382.496C623.928,382.215 621.032,377.197 622.218,375ZM635.939,355.927C641.574,341.446 629.348,325.653 647.835,316.872C645.335,321.1 643.578,326.016 644.343,332.686C647.619,329.352 656.853,329.036 660.626,332.265C646.378,328.844 635.939,355.927 635.939,355.927Z",
    style: {
      fill: "rgb(255,152,36)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32193,0,0,1.32193,-436.915,-138.842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.855,422.049C513.748,415.348 524.739,424.128 517.947,398.072C525.792,403.311 526.118,410.547 527.324,416.471C530.538,413.425 529.255,406.01 527.642,400.613C536.613,408.157 537.19,420.919 538.594,421.503C538.69,418.988 541.074,416.866 542.748,414.904C543.233,418.473 543.893,426.164 545.199,427.742C550.758,418.745 545.044,408.003 547.109,407.049C564.326,429.733 550.984,456.457 528.349,450.048C516.568,447.806 498.088,444.265 497.103,434.843C496.373,427.858 501.781,427.969 501.063,419.196C507.603,418.841 507.885,421.963 508.855,422.049ZM523.178,378.55C524.404,377.226 525.744,376.243 527.23,375.681C527.889,375.431 528.742,376.076 527.765,377.949C528.711,377.848 531.243,375.142 532.304,375.368C532.543,374.011 529.823,372.829 528.46,372.965C527.097,373.101 522.64,374.307 523.178,378.55ZM480.823,361.695C478.461,357.852 480.491,352.485 484.168,350.488C480.501,355.83 485.504,355.72 480.823,361.695Z",
    style: {
      fill: "rgb(254,208,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32193,0,0,1.32193,-263.938,-141.486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.074,435.59C380.641,419.114 386.25,418.089 385.214,404.829C394.584,413.646 389.267,428.575 389.888,427.128C392.209,426.173 393.103,424.144 393.972,421.887C399.888,429.75 387.262,442.075 393.196,447.205C396.225,434.898 403.231,432.969 403.846,419.242C410.898,423.636 407.219,435.432 407.376,437.744C408.907,438.741 412.503,437.317 415.514,433.334C416.961,451.102 404.947,453.17 396.096,450.956C388.163,451.614 368.463,446.715 368.138,437.088C367.906,430.214 371.869,429.989 371.855,422.986C371.95,424.826 376.549,422.16 377.074,435.59Z",
    style: {
      fill: "rgb(255,252,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32193,0,0,1.32193,-875.635,-276.748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M749.8,345.291C750.946,341.021 757.668,338.546 759.554,334.671C761.84,329.972 756.106,319.821 764.04,316.184C761.371,339.559 806.648,318.773 782.481,358.002C782.848,346.386 771.218,336.751 763.721,341.987C751.131,350.78 759.246,358.313 758.94,364.25C758.484,373.112 751.096,370.138 750.018,382.208C749.414,388.974 752.548,392.308 769.509,392.861C772.807,392.968 775.315,401.365 780.274,398.072C787.113,393.532 791.62,399.64 791.789,406.261C791.941,412.244 779.921,422.903 779.941,426.254C779.982,433.054 785.779,437.334 791.05,433.383C787.296,455.322 769.427,457.811 757.494,455.226C750.97,456.213 717.355,453.588 726.626,428.648C729.409,421.161 743.518,431.109 746.01,424.544C749.096,416.413 742.201,418.704 742.117,402.829C743.633,404.476 746.26,405.021 748.779,404.251C747.984,393.539 730.308,377.482 738.648,366.67C744.236,368.77 747.993,373.316 748.371,358.724C748.458,355.378 749.094,347.921 749.8,345.291ZM741.784,359.545C740.608,360.41 739.005,357.814 737.881,356.092C736.758,354.37 738.397,352.58 739.573,351.715C740.75,350.849 742.864,350.874 743.988,352.596C745.111,354.318 742.961,358.679 741.784,359.545ZM759.872,313.454C758.969,313.52 758.386,311.457 758.332,310.54C758.279,309.623 758.509,308.098 759.55,307.952C761.137,307.729 762.861,308.123 762.801,309.476C762.689,312.06 760.746,313.391 759.872,313.454Z",
    style: {
      fill: "rgb(255,92,13)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32193,0,0,1.32193,-875.635,-276.748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M746.846,389.42C746.933,386.075 747.65,387.796 749.018,383.208C748.414,389.974 751.548,394.308 768.509,394.861C771.807,394.968 773.315,403.365 778.274,400.072C785.113,395.532 789.62,401.64 789.789,408.261C789.941,414.244 777.921,422.903 777.941,426.254C777.982,433.054 783.838,437.663 786.717,435.971C785.327,453.278 769.427,455.811 757.494,453.226C750.97,454.213 721.847,451.549 728.626,430.648C731.09,423.05 745.518,433.109 748.01,426.544C751.096,418.413 745.201,421.704 745.117,405.829C746.633,407.476 749.26,408.021 751.779,407.251C750.984,396.539 730.308,378.482 738.648,367.67C735.121,376.539 739.922,384.906 746.846,389.42ZM741.769,358.97C740.593,359.836 739.085,358.144 739.215,356.092C739.278,355.094 741.302,354.035 742.413,354.76C744.134,355.884 742.946,358.105 741.769,358.97ZM759.887,312.824C758.983,312.889 759.055,312.154 759.001,311.237C758.948,310.32 760.589,309.512 761.19,310.726C761.712,311.782 760.761,312.76 759.887,312.824Z",
    style: {
      fill: "rgb(255,152,36)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32193,0,0,1.32193,-875.635,-276.748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M737.601,432.267C742.389,424.687 753.227,434.617 746.827,412.105C754.672,417.344 759.56,422.621 760.766,428.546C763.98,425.499 765.562,402.034 763.949,396.636C772.92,404.18 767.582,426.738 768.985,427.321C769.278,420.026 771.963,415.926 773.637,413.965C770.525,433.495 777,422.899 774.731,442.934C782.19,441.979 786.999,436.774 789.064,435.821C787.304,442.144 776.619,456.548 757.314,452.874C745.533,450.632 740.263,457.141 727.932,438.12C725.817,434.858 728.125,430.574 731.113,428.678C731.625,431.645 736.631,432.181 737.601,432.267ZM778.381,409.836C777.821,411.58 778.699,415.525 780.205,415.018C787.256,412.647 786.638,408.91 787.214,407.115C787.679,405.667 784.469,403.094 783.106,403.23C781.743,403.365 778.957,408.041 778.381,409.836ZM742.183,384.164C741.002,382.243 739.735,379.962 739.223,377.913C738.71,375.863 738.953,374.045 740.791,373.046C737.124,378.388 746.864,378.189 742.183,384.164ZM741.127,356.861C741.638,356.861 742.053,357.247 742.053,357.723C742.053,358.199 741.638,358.585 741.127,358.585C740.616,358.585 740.2,358.199 740.2,357.723C740.2,357.247 740.616,356.861 741.127,356.861Z",
    style: {
      fill: "rgb(254,208,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32193,0,0,1.32193,-392.043,-279.392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.719,420.585C390.546,421.865 393.201,410.502 388.011,399.817C397.621,407.464 396.511,419.189 394.318,426.826C397.505,426.648 399.018,423.105 399.639,421.659C406.574,432.159 390.031,432.465 396.98,448.102C395.088,450.469 390.802,448.768 387.189,442.677C384.691,445.779 387.523,448.715 389.747,453.365C363.361,456.283 364.668,436.707 366.219,435.722C390.55,444.36 384.38,417.107 383.629,413.595C387.804,413.562 388.936,418.423 389.719,420.585Z",
    style: {
      fill: "rgb(255,252,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.358415,-1.3947e-07,1.4128e-07,0.404343,-4.9916,224.936)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 455.911,
    cy: 582.863,
    rx: 210.993,
    ry: 37.606,
    style: {
      fill: "rgb(15,36,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.62549,-107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.578,567.613L86.258,567.613L53.761,423.741L186.318,393.8L225.578,567.613Z",
    style: {
      fill: "rgb(58,74,94)"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,989.738,-107.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M759.515,567.613L755.7,567.613L795.085,393.414C795.298,392.471 796.235,391.88 797.178,392.093L929.736,422.034C930.678,422.247 931.27,423.184 931.057,424.127L901.61,567.613L895.454,567.613L927.257,425.062L798.114,395.892L759.515,567.613Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.975427,-0.220323,0.220323,0.975427,-105.643,-96.174)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      fill: "rgb(32,175,228)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.62549,-107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.944,430.19L173.16,429.462L168.867,438.582L163.869,436.917L161.215,438.874L157.33,421.673L173.21,418.086L175.944,430.19Z",
    style: {
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-63.53,-35.9673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.944,430.19L173.16,429.462L168.867,438.582L163.869,436.917L161.215,438.874L157.33,421.673L173.21,418.086L175.944,430.19Z",
    style: {
      fill: "rgb(32,175,228)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.62549,-107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.944,430.19L180.404,449.938L164.525,453.525L161.215,438.874L163.869,436.917L168.867,438.582L173.16,429.462L175.944,430.19Z",
    style: {
      fill: "rgb(32,175,228)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-63.53,-35.9673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.944,430.19L180.404,449.938L164.525,453.525L161.215,438.874L163.869,436.917L168.867,438.582L173.16,429.462L175.944,430.19Z",
    style: {
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.975427,-0.220323,0.220323,0.975427,-93.7178,-43.3777)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      fill: "rgb(32,175,228)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.975427,-0.220323,0.220323,0.975427,-146.531,-86.9384)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      fill: "rgb(32,175,228)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.975427,-0.220323,0.220323,0.975427,-158.391,-139.446)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.975427,-0.220323,0.220323,0.975427,-199.519,-130.157)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.455,
    y: 513.98,
    width: 16.28,
    height: 32.655,
    style: {
      fill: "rgb(32,175,228)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.62549,-107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.821,567.613L140.639,567.613L133.809,537.374L162.526,530.888L170.821,567.613Z",
    style: {
      fill: "rgb(32,175,228)"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,989.738,-107.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M814.479,567.613L810.583,567.613L818.878,530.502C819.091,529.559 820.028,528.968 820.971,529.181L849.687,535.667C850.63,535.88 851.222,536.817 851.009,537.76L844.512,567.613L840.95,567.613L847.209,538.695L821.906,532.98L814.479,567.613Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.62549,-107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.784,567.613L104.094,567.613L99.099,545.502L114.979,541.915L120.784,567.613Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.32193,0,0,1.32193,1898.02,140.823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709.5,176.838C709.454,168.252 713.718,160.359 719.802,158.229C717.365,165.439 721.052,170.436 723.707,170.394C733.835,170.235 729.344,156.344 737.107,150.614C745.888,144.135 750.803,147.515 751.776,141.272C752.58,136.109 735.794,133.938 736.442,127.974C737.695,116.457 756.257,122.496 757.222,104.898C760.528,108.894 756.896,115.149 758.904,120.827C761.207,127.338 769.841,129.975 768.709,137.659C765.877,156.885 746.843,147.649 740.99,170.254C739.287,176.83 742.456,190.479 753.488,180.963C759.691,184.676 746.203,201.999 762.97,197.876C770.859,195.935 762.489,184.807 767.449,181.514C769.586,186.842 774.533,189.481 774.89,192.925C775.507,198.877 770.34,204.13 770.36,207.481C770.401,214.28 780.349,216.298 779.669,227.691C779.111,237.021 765.147,247.13 750.46,246.035C741.597,245.374 726.959,240.13 726.449,226.294C726.154,218.312 732.007,217.052 734.418,210.456C737.768,201.292 709.584,192.712 709.5,176.838Z",
    style: {
      fill: "rgb(255,92,13)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.32193,0,0,1.32193,1898.02,140.823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M710.861,176.838C714.214,179.617 715.936,181.669 719.476,179.031C722.197,177.003 721.052,171.773 723.707,171.745C735.466,171.621 730.938,157.328 738.702,151.599C736.28,155.453 733.691,163.636 736.082,166.891C740.81,154.862 749.224,150.65 755.978,151.296C749.32,154.964 743.505,156.68 739.99,170.254C738.287,176.83 741.456,192.479 752.488,182.963C758.691,186.676 746.203,202.999 762.97,198.876C770.859,196.935 764.497,184.857 767.449,182.514C769.586,187.842 773.533,190.481 773.89,193.925C774.507,199.877 768.34,204.13 768.36,207.481C768.401,214.28 778.349,216.298 777.669,227.691C777.111,237.021 765.147,246.13 750.46,245.035C741.597,244.374 727.959,240.13 727.449,226.294C727.154,218.312 733.007,217.052 735.418,210.456C738.768,201.292 710.944,192.712 710.861,176.838Z",
    style: {
      fill: "rgb(255,152,36)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.32193,0,0,1.32193,1602.29,-134.283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.329,391.171C507.415,397.584 508.896,397.935 512.159,399.76C512.848,396.987 508.146,387.933 513.131,381.374C513.641,395.326 518.274,396.571 522.125,401.628C522.607,401.311 521.716,397.55 523.445,395.851C525.562,405.569 532.067,415.417 533.471,416.001C533.567,413.486 532.736,410.905 534.411,408.943C534.896,412.512 535.969,413.828 537.275,415.406C538.786,409.502 541.484,408.609 543.549,407.656C540.31,416.867 549.487,421.365 552.224,428.354C554.716,434.716 550.984,456.457 528.349,450.048C516.568,447.806 506.015,446.617 505.029,437.194C504.299,430.21 510.476,428.486 513.032,425.303C521.962,414.185 501.166,401.772 501.329,391.171ZM537.487,440.435C536.613,442.47 536.309,445.984 540.519,446.646C542.197,446.91 545.851,442.962 545.665,439.619C547.031,441.221 546.609,442.469 546.638,443.926C549.148,442.767 550.694,432.194 549.101,429.448C548.996,431.065 548.035,432.952 547.998,432.472C547.617,427.503 542.335,426.97 542.127,421.167C541.621,421.843 541.085,427.23 539.998,425.915C538.911,424.6 539.929,420.583 538.005,419.769C538.936,424.108 537.194,429.138 539.123,436.625C540.76,442.976 538.596,441.388 537.487,440.435ZM506.932,388.602C504.57,384.758 504.172,381.635 504.865,379.114C505.557,376.593 507.34,374.674 509.338,373.239C507.242,378.782 511.612,382.627 506.932,388.602Z",
    style: {
      fill: "rgb(254,208,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.32193,0,0,1.32193,1429.32,-136.927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.516,407.912C382.817,407.557 382.285,406.719 382.51,404.821C387.547,413.566 400.067,417.859 399.717,432.007C401.2,433.002 400.44,426.798 401.061,425.351C408.245,432.434 402.452,441.196 398.95,443.153C399.641,439.209 398.864,436.498 397.758,433.952C393.709,432.644 391.187,436.32 391.458,441.443C389.024,440.07 387.854,438.46 387.806,435.837C385.914,438.204 386.064,440.948 387.189,442.677C389.065,445.562 391.007,447.909 404.279,449.428C399.987,451.191 398.124,450.03 394.864,449.972C376.233,449.639 379.755,428.521 381.305,427.537C381.401,429.377 381.418,432.778 382.816,430.861C384.974,427.903 386.784,425.315 386.033,421.804C384.477,414.53 366.129,403.762 366.177,394.12C366.728,398.408 376.65,403.117 381.516,407.912Z",
    style: {
      fill: "rgb(255,252,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,67.431,-107)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 461.998,
    cy: 566.023,
    rx: 210.993,
    ry: 37.606,
    style: {
      fill: "rgb(15,36,35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.42,201.397C420.721,191.207 439.172,188.865 441.894,188.865C444.616,188.865 447.265,181.711 447.563,179.651C447.861,177.591 448.611,178.18 454.06,180.57C459.51,182.96 471.656,170.392 474.336,181.606C480.681,184.462 490.127,178.167 500,170.651C495.673,181.624 485.338,192.739 477.865,201.397C484.714,204.279 488.338,204.527 491.779,206.718C485.987,209.653 475.488,208.848 474.451,215.26C473.297,222.387 470.099,222.672 468.944,234.128C442.861,200.507 417.8,201.572 406.42,201.397Z",
    style: {
      fill: "rgb(25,84,23)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.728,401.92C532.615,382.762 543.643,388.874 537.617,375C549.79,375.667 556.214,379.937 560.944,363.709C564.399,379.329 577.131,365.542 581.418,375C572.277,377.992 553.277,387.507 539.728,401.92Z",
    style: {
      fill: "rgb(25,84,23)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,45.9301,-21.5114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M551.777,390.942C554.966,375.684 564.002,386.325 557.135,371.85C569.308,372.516 571.518,364.102 576.339,374.665C586.144,368.383 585.749,375.842 587.783,385.22C577.347,384.877 556.663,386.68 551.777,390.942Z",
    style: {
      fill: "rgb(25,84,23)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,99.2593,-20.3966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.437,385.773C563.881,380.646 558.006,373.772 565.849,371.85C576.663,385.854 577.996,366.961 582.817,377.524C578.272,387.209 580.819,387.646 582.852,397.024C575.568,392.111 561.146,385.941 552.437,385.773Z",
    style: {
      fill: "rgb(25,84,23)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,41.2524,49.7794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.54,188.733C445.841,178.542 454.082,182.393 456.34,167.911C461.203,183.201 465.844,183.528 470.146,183.034C478.216,170.765 490.127,178.167 500,170.651C495.673,181.624 491.656,186.418 495.767,191.263C482.149,196.37 479.879,209.144 483.32,211.335C477.528,214.271 473.399,215.707 472.361,222.119C471.208,229.246 459.903,229.814 458.748,241.27C448.127,216.002 438.783,201.768 431.54,188.733Z",
    style: {
      fill: "rgb(25,84,23)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.585745,0.810495,-0.810495,0.585745,463.778,-213.347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.243,584.397C518.673,584.397 521.402,588.383 521.402,595.774C521.402,603.166 517.497,602.059 515.243,611.182C511.812,611.182 509.027,605.181 509.027,597.79C509.027,590.398 511.812,584.397 515.243,584.397Z",
    style: {
      fill: "rgb(156,138,30)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.911572,0.935249,-1.19252,1.16233,876.163,-927.882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.243,584.397C518.164,592.412 523.269,594.511 523.269,601.902C517.935,604.475 515.406,605.903 511.084,609.056C506.588,601.142 511.812,584.397 515.243,584.397Z",
    style: {
      fill: "rgb(156,138,30)",
      stroke: "black",
      strokeWidth: "2.34px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.332756,1.2629,-1.61031,0.424293,1445.81,-629.203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.243,584.397C519.506,588.635 521.387,593.402 521.387,600.793C521.387,608.185 508.444,608.951 508.444,601.56C508.444,594.169 511.391,589.093 515.243,584.397Z",
    style: {
      fill: "rgb(156,138,30)",
      stroke: "black",
      strokeWidth: "2.34px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.244826,1.28285,-1.63575,-0.312174,1745.52,-169.807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.243,584.397C518.673,584.397 521.503,591.611 521.503,599.003C521.503,606.394 509.027,605.181 509.027,597.79C509.027,590.398 512.126,591.584 515.243,584.397Z",
    style: {
      fill: "rgb(156,138,30)",
      stroke: "black",
      strokeWidth: "2.34px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M325.932,286.325C327.953,274.952 331.686,261.965 337.795,249.574C350.377,224.048 372.96,201.064 411.121,199.682C427.591,199.086 442.965,206.202 456.935,218.971C475.764,236.183 492.07,263.733 505.131,296.12C527.418,288.059 601.737,258.302 617.985,256.503C647.117,253.277 661.471,286.106 644.122,302.281C627.801,317.498 586.6,332.651 527.818,370.422C530.409,382.034 532.625,393.736 534.443,405.35C612.741,333.696 708.817,363.745 707.423,423.699C707.404,424.499 706.826,425.177 706.043,425.346C705.26,425.515 704.491,425.116 704.107,424.413C684.759,389.1 609.834,379.481 594.523,458.145C588.013,491.586 582.032,518.707 529.744,545.258C528.029,548.051 527.629,554.753 523.666,560.704C511.935,580.17 490.078,589.027 473.871,588.329C462.415,587.836 454.578,582.472 453.395,573.263C452.504,566.335 452.694,567.103 452.06,565.505C426.65,573.341 391.901,570.754 362.2,558.565C359.507,561.489 349.494,571.746 335.521,577.038C327.004,580.263 315.929,578.407 306.227,574.177C296.54,569.953 288.275,563.383 285.22,557.524C280.795,549.039 281.999,538.365 285.862,527.681C291.443,512.245 302.487,496.772 308.518,488.342C308.586,488.247 308.663,488.16 308.745,488.083C305.826,459.089 314.394,421.94 341.274,376.444C340.337,375.935 339.528,375.291 338.86,374.508C321.221,380.391 303.923,384.388 290.851,384.872C283.549,385.143 276.471,378.955 272.629,369.005C264.202,347.175 271.034,307.018 325.096,286.427C325.372,286.322 325.658,286.291 325.932,286.325Z",
    style: {
      fill: "rgb(47,138,44)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.739,487.209C310.755,491.775 311.757,494.524 312.187,498.792C312.104,498.869 291.443,526.245 285.862,541.681C284.647,545.041 283.695,548.4 283.099,551.691C281.446,544.389 282.841,536.038 285.862,527.681C291.354,512.492 303.649,495.723 309.739,487.209ZM342.962,376.121C344.725,375.569 347.689,381.78 348.626,382.289C327.049,418.809 309.92,458.105 308.412,483.964C306.855,458.661 315.714,423.337 342.962,376.121ZM534.443,419.35C533.594,414.286 533.609,409 534.443,405.35C612.741,333.696 686.206,372.612 693.365,387.413C664.127,362.957 607.127,352.834 534.443,419.35ZM325.719,288.062C325.719,288.062 326.268,292.074 325.719,295.166C325.445,295.132 325.372,300.322 325.096,300.427C287.545,314.729 272.78,338.472 270.088,358.959C267.009,336.404 279.161,305.795 325.719,288.062ZM491.579,300.766C507.371,301.063 602.157,258.256 617.985,256.503C641.629,253.885 655.538,275.016 650.666,291.715C647.278,279.301 635.217,268.595 617.985,270.503C601.737,272.302 527.418,302.059 505.131,310.12C500.614,311.753 491.476,310.279 491.579,300.766ZM499.701,298.213C487.6,271.152 473.328,247.956 456.935,232.971C442.965,220.202 427.591,213.086 411.121,213.682C372.96,215.064 350.377,238.048 337.795,263.574C334.298,270.668 326.792,281.89 326.792,281.89C328.946,271.642 332.467,260.381 337.795,249.574C350.377,224.048 372.96,201.064 411.121,199.682C427.591,199.086 442.965,206.202 456.935,218.971C475.679,236.105 491.581,264.691 504.622,296.896L499.701,298.213Z",
    style: {
      fill: "rgb(98,161,96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.107,412.413C704.491,413.116 707.508,420.053 707.423,423.699C707.404,424.499 706.826,425.177 706.043,425.346C705.26,425.515 704.491,425.116 704.107,424.413C684.759,389.1 609.834,379.481 594.523,458.145C588.013,491.586 582.032,518.707 529.744,545.258C528.029,548.051 527.629,554.753 523.666,560.704C511.935,580.17 490.078,589.027 473.871,588.329C462.415,587.836 454.578,582.472 453.395,573.263C452.504,566.335 452.694,567.103 452.06,565.505C426.65,573.341 391.901,570.754 362.2,558.565C359.507,561.489 349.494,571.746 335.521,577.038C327.004,580.263 315.929,578.407 306.227,574.177C296.54,569.953 288.275,563.383 285.22,557.524C282.343,552.007 284.115,543.406 285.22,545.524C288.275,551.383 296.54,557.953 306.227,562.177C315.929,566.407 327.004,568.263 335.521,565.038C349.494,559.746 359.507,549.489 362.2,546.565C391.901,558.754 426.65,561.341 452.06,553.505C452.694,555.103 452.504,554.335 453.395,561.263C454.578,570.472 462.415,575.836 473.871,576.329C490.078,577.027 511.935,568.17 523.666,548.704C527.629,542.753 531.303,536.294 532.95,530.484C585.238,503.934 588.013,479.586 594.523,446.145C609.834,367.481 684.759,377.1 704.107,412.413ZM272.629,369.005C270.153,362.591 271.355,353.704 272.629,357.005C276.471,366.955 283.549,373.143 290.851,372.872C303.923,372.388 367.79,357.958 404.133,332.886C408.618,329.068 411.888,322.019 416.034,322.464C411.245,338.104 406.68,339.92 403.68,342.25C354.809,372.917 302.928,384.425 290.851,384.872C283.549,385.143 276.471,378.955 272.629,369.005ZM511.233,382.687C505.564,385.735 501.808,373.661 505.64,371.198C564.422,333.428 627.801,305.498 644.122,290.281C646.166,288.375 647.77,286.239 648.961,283.957L651.619,283.957C651.843,290.619 649.514,297.254 644.122,302.281C628.01,317.303 525.964,360.985 511.233,382.687Z",
    style: {
      fill: "rgb(42,114,37)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M339.581,372.525C349.324,386.629 388.212,354.856 411.454,352.431",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.69891,6.48641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.747,364.839C405.273,357.789 406.598,353.184 404.384,347.141C400.265,347.97 394.783,349.57 390.424,351.859C393.044,353.603 395.725,356.669 404.747,364.839Z",
    style: {
      fill: "rgb(230,230,230)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-19.0089,18.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.005,361.878C404.531,354.827 404.939,350.056 402.726,344.013C400.357,345.415 393.241,348.859 388.882,351.149C391.655,355.495 394.983,356.953 404.005,361.878Z",
    style: {
      fill: "rgb(230,230,230)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99231,0.123778,-0.123778,0.99231,2.62959,-18.131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.005,361.878C404.531,354.827 407.441,349.32 405.228,343.277C402.859,344.678 395.957,349.214 389.042,348.779C391.816,353.125 394.983,356.953 404.005,361.878Z",
    style: {
      fill: "rgb(230,230,230)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M529.744,545.258C581.49,516.886 588.273,495.724 595.417,454.542C606.569,390.255 686.485,377.886 707.358,432.645C710.813,337.227 575.21,351.951 533.25,409.813",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.749,300.38C494.818,300.742 499.881,299.771 503.999,298.256C539.186,284.868 605.322,259.666 618.178,258.242C645.481,255.219 659.188,285.841 642.929,301.001C626.795,316.043 583.877,332.765 526.081,369.697C525.474,370.085 518.934,373.189 511.643,382.687",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.941,489.361C299.995,503.262 276.228,536.498 286.772,556.715C292.618,567.925 318.629,581.564 334.902,575.401C351.174,569.239 360.973,557.492 360.973,557.492",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.702,375.784C243.82,542.938 389.886,586.186 453.114,564.669",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.719,315.441C325.719,315.441 384.95,296.566 402.3,300.576C418.068,304.22 420.654,327.485 408.002,338.098C384.351,357.937 323.893,381.897 290.786,383.123C268.476,383.95 250.424,316.74 325.719,288.062",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.912,369.91C543.13,446.462 543.965,527.128 522.187,559.767C503.258,591.232 457.056,594.177 454.351,573.133C449.798,537.715 455.165,485.501 439.027,462.375",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.197,313.996C322.771,291.645 336.406,204.139 411.185,201.431C449.554,200.041 481.676,241.98 504.082,298.205",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.838699,0.544596,-0.544596,0.838699,353.535,-199.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M507.604,595.598C507.604,588.206 521.458,590.398 521.458,597.79C521.458,605.181 519.285,603.822 515.243,611.182C511.812,611.182 507.604,602.989 507.604,595.598Z",
    style: {
      fill: "rgb(156,138,30)",
      stroke: "black",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.42672,-0.172854,0.120275,0.992741,-314.221,79.4018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.027,597.79C509.129,589.198 520.774,583.556 521.477,595.036C521.928,602.399 519.069,606.481 515.243,611.182C512.072,607.751 508.94,605.18 509.027,597.79Z",
    style: {
      fill: "rgb(156,138,30)",
      stroke: "black",
      strokeWidth: "2.83px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.917597,-1.01853,0.548707,0.494332,-280.826,796.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.869,594.088C508.869,586.696 521.555,585.185 521.555,592.577C521.555,599.968 518.673,611.182 515.243,611.182C512.974,603.65 508.869,601.479 508.869,594.088Z",
    style: {
      fill: "rgb(156,138,30)",
      stroke: "black",
      strokeWidth: "3.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.905794,-0.423718,0.219887,0.470059,-256.579,509.979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.027,597.79C509.096,583.47 520.762,575.483 521.458,597.79C521.688,605.168 516.37,621.444 515.118,615.291C513.374,606.725 508.992,605.181 509.027,597.79Z",
    style: {
      fill: "rgb(156,138,30)",
      stroke: "black",
      strokeWidth: "4.39px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.89014,0.455687,-0.349743,0.683187,56.1928,-70.5339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.027,597.79C508.676,585.506 522.428,588.725 521.467,596.053C520.572,602.876 518.482,612.496 515.52,612.794C512.107,613.138 509.238,605.176 509.027,597.79Z",
    style: {
      fill: "rgb(156,138,30)",
      stroke: "black",
      strokeWidth: "3.93px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.63166,0.648066,-0.902014,0.879179,613.862,-565.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.243,584.397C517.613,588.602 519.411,592.608 519.851,595.843C520.854,603.199 526.914,601.744 517.426,608.364C514.965,610.081 509.027,605.181 509.027,597.79C509.027,590.398 511.812,584.397 515.243,584.397Z",
    style: {
      fill: "rgb(156,138,30)",
      stroke: "black",
      strokeWidth: "3.19px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.229539,0.875384,-1.21841,0.319484,1029.67,-328.457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.243,584.397C518.673,584.397 517.382,589.333 521.458,597.79C524.824,604.774 522.927,607.619 513.884,606.538C510.5,606.134 509.027,605.181 509.027,597.79C509.027,590.398 511.812,584.397 515.243,584.397Z",
    style: {
      fill: "rgb(156,138,30)",
      stroke: "black",
      strokeWidth: "3.19px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.444439,0.788326,-0.753089,-0.424573,1091.86,186.258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.243,584.397C518.673,584.397 516.408,594.006 520.423,600.007C524.474,606.062 520.953,611.64 514.305,609.262C511.059,608.101 509.027,605.181 509.027,597.79C509.027,590.398 511.812,584.397 515.243,584.397Z",
    style: {
      fill: "rgb(156,138,30)",
      stroke: "black",
      strokeWidth: "3.95px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32193,0,0,1.32193,-138.831,-704.931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.359,613.049C304.673,635.266 309.726,635.166 317.032,631.842C313.963,658.37 302.812,656.659 290.213,657.122C275.974,659.714 267.987,643.391 271.011,633.537C274.424,622.415 294.082,623.38 296.359,613.049ZM287.599,613.629C269.004,603.938 294.681,596.814 296.449,592.158C301.528,603.152 289.069,603.501 287.599,613.629ZM293.178,582.722C289.851,582.618 290.402,572.179 291.982,570.153C296.242,564.69 310.688,562.738 312.068,555.414C322.129,583.284 295.233,572.992 293.178,582.722ZM306.418,549.904C309.445,548.047 309.718,549.841 309.62,550.852C309.522,551.862 308.297,554.599 307.016,554.314C305.822,554.049 305.722,550.33 306.418,549.904Z",
    style: {
      fill: "rgb(255,92,13)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32193,0,0,1.32193,-138.831,-704.931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.359,624.049C302.673,646.266 308.726,637.166 316.032,633.842C312.541,656.471 302.812,655.659 290.213,656.122C275.974,658.714 269.987,644.391 273.011,634.537C276.424,623.415 292.082,634.38 294.359,624.049ZM284.217,609.554C281.498,605.923 285.489,602.516 287.424,601.793C289.039,605.014 285.868,607.752 284.217,609.554ZM294.291,575.691C294.648,568.452 297.923,568.676 308.355,563.985C305.26,570.7 300.767,573.962 294.291,575.691Z",
    style: {
      fill: "rgb(255,152,36)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.19912,0,0,1.33884,-84.2281,-160.608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.006,218.61C257.386,220.171 260.605,220.398 264.901,224.554C264.872,210.483 276.598,206.733 277.462,206.427C269.498,221.82 276.616,224.393 277.132,225.358C277.612,222.631 277.658,219.31 280.409,216.247C282.197,218.449 279.199,221.912 281.106,225.115C285.58,224.215 286.451,223.124 286.991,220.269C289.886,221.773 285.37,227.578 287.042,229.618C290.619,229.227 295.506,226.568 296.364,224.129C295.145,247.541 262.3,242.333 258.453,233.012C257.237,230.066 254.466,226.654 256.006,218.61Z",
    style: {
      fill: "rgb(254,208,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.859323,0,0,0.845313,-195.81,-45.8896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527.881,233.097C529.97,236.772 523.65,240.718 520.709,241.829C496.743,243.935 488.445,225.833 489.365,214.869C492.575,226.12 499.021,230.447 503.923,231.122C505.748,224.645 508.209,221.215 506.206,207.466C514.041,210.227 515.127,225.667 515.006,233.532C514.98,235.194 522.326,228.148 522.747,225.02C523.344,224.833 523.709,235.328 524.43,236.591C525.266,238.056 527.805,236.162 527.881,233.097Z",
    style: {
      fill: "rgb(255,251,224)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32193,0,0,1.32193,-281.247,-395.776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.87,626.527C290.657,649.317 307.582,634.005 302.792,614.966C320.408,660.113 302.812,656.659 290.213,657.122C275.974,659.714 273.44,647.832 276.258,640.24C278.997,632.863 288.905,629.655 289.87,626.527ZM290.571,604.319C286.974,596.438 293.316,592.577 296.471,590.513C301.55,601.507 292.506,601.57 290.571,604.319ZM288.896,549.097C294.79,549.363 296.659,546.789 297.528,543.676C298.436,540.425 298.879,535.606 304.407,536.012C308.522,555.511 291.411,554.514 288.896,549.097Z",
    style: {
      fill: "rgb(255,92,13)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32193,0,0,1.32193,-281.247,-395.776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.804,629.246C287.201,634.372 290.65,640.081 293.41,640.24C305.979,640.966 303.692,635.03 304.298,627.481C306.774,631.087 308.509,642.595 309.053,641.338C310.871,652.6 301.138,655.362 291.153,655.729C279.19,657.795 274.685,648.643 277.503,641.051C280.242,633.674 286.839,632.373 287.804,629.246Z",
    style: {
      fill: "rgb(255,152,36)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32193,0,0,1.32193,-281.247,-395.776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.899,632.565C286.296,637.691 288.73,642.337 291.187,644.152C292.189,642.213 292.439,640.082 293.41,640.24C293.606,643.637 295.291,642.345 296.306,644.054C299.52,642.813 302.455,638.758 303.06,631.209C305.537,634.815 303.777,640.797 304.36,642.883C304.763,644.327 305.853,643.507 306.396,642.25C308.214,653.512 301.25,654.864 291.265,655.232C279.302,657.298 275.579,648.539 278.398,640.948C281.136,633.571 285.934,635.692 286.899,632.565Z",
    style: {
      fill: "rgb(254,208,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.859323,0,0,0.845313,-338.226,263.265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M522.222,236.759C523.059,238.225 521.443,240.887 518.502,241.998C497.102,244.103 490.8,232.326 499.649,216.999C500.442,222.375 501.307,228.777 506.21,229.452C507.002,226.497 508.473,224.287 509.003,220.371C511.528,222.865 513.222,227.211 513.101,235.076C513.075,236.738 519.605,234.303 520.026,231.174C520.623,230.987 521.501,235.496 522.222,236.759Z",
    style: {
      fill: "rgb(255,251,224)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinoDab);
export default __webpack_public_path__ + "static/media/DinoDab.f82a7276b03778c539d8e3164d1621d4.svg";
export { ForwardRef as ReactComponent };